export default __webpack_public_path__ + "static/media/fassaden1.42b9b1ef.jpg";